import { useStaticQuery, graphql } from 'gatsby';

export const useProfileInfo = () => {
  const data = useStaticQuery<Queries.ProfileQuery>(graphql`
    query Profile {
      avatar: file(absolutePath: { regex: "/profile.jpg/" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 200, height: 200, quality: 100)
        }
      }
      site {
        siteMetadata {
          description
          author {
            name
            summary
            email
          }
          social {
            github
            linkedin
            inflearn
            rss
          }
        }
      }
    }
  `);

  return data;
};
